import Search from "@mui/icons-material/Search";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";
import { FontSize } from "../../../assets/font";

// Grid Components //
export const TrendingSearchesOuterWrapper = styling(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: Color.homepageGrey,
}));

export const TrendingSearchesContainer = styling(Grid)(({ theme }) => ({
  display: "grid",
  width: "100%",
  maxWidth: "1440px",
  padding: "0 clamp(0px, calc((100% - 1140px) / 2), 150px)",
  gridTemplateColumns: "repeat(6, var(--trending-card-size))",
  justifyContent: "center",
  alignContent: "start",
  "--trending-card-size": "clamp(127.5px, 13.5vw, 170px)",
  columnGap: "24px",
  rowGap: "12px",

  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "repeat(4, var(--trending-card-size))",
    "--trending-card-size":
      "clamp(63.75px, calc(50vw - 163.5px), 127.5px)",
    columnGap: "20px",
    rowGap: "12px",
  },

  [theme.breakpoints.down("sm")]: {
    columnGap: "10px",
    rowGap: "10px",
  },
}));

export const TrendingSearchTitle = styling(Typography)(({ theme }) => ({
  gridColumn: "1 / -1",
  justifySelf: "start",
  textAlign: "left",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
  [theme.breakpoints.down("lg")]: {
    display: "none",
  },
}));

export const ChipsContainer = styling(Grid)(({ theme }) => ({
  width: "80%",
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  margin: "35px 0",

  [theme.breakpoints.down("tablet")]: {
    width: "100%",
    padding: "0 0 0 0",
  },
}));

export const CategoryIconGrid = styling(Grid)(({ theme }) => ({
  width: "var(--trending-card-size, 170px)",
  height: "var(--trending-card-size, 170px)",
  color: "#222",

  "& svg": {
    width: "calc(var(--trending-card-size, 170px) * 0.13)",
    height: "calc(var(--trending-card-size, 170px) * 0.13)",
  },

  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    display: "block",
  },

}));

// Box Component //
export const CategoryBox = styling(Box)(({ theme, type }) => ({
  display: "flex",
  height: "var(--trending-card-size, 170px)",
  width: "var(--trending-card-size, 170px)",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  transition: "transform 200ms ease, box-shadow 200ms ease",

  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.12)",
  },

  "& img": {
    transition: "transform 200ms ease",
  },

  "&:hover img": {
    transform: "scale(1.05)",
  },
}));

export const CategoryBoxItem = styling(Box)({
  alignSelf: "center",
  justifySelf: "center",
});

// Typography Component //
export const TitleStyled = styling(Typography)(({ theme }) => ({
  fontSize: "2rem",
  fontWeight: FontSize.bold,

  [theme.breakpoints.down("tablet")]: {
    fontSize: FontSize.desktopHeader,
  },
}));

export const CategoryTitle = styling(Typography)(({ theme }) => ({
  color: "#222",
  textAlign: "center",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "20px",
  textTransform: "capitalize",

  [theme.breakpoints.down("tablet")]: {
    fontSize: "9px",
    lineHeight: "15px",
  },
}));

// Chip Component //
export const ChipStyled = styling(Chip)((props) => ({
  backgroundColor: "rgba(81, 42, 204, 0.1)",
  padding: "5px 10px",
  margin: "10px 5px",

  "&:hover": {
    backgroundColor: "rgba(81, 42, 204, 0.3)",
  },

  "&:focus": {
    backgroundColor: "rgba(81, 42, 204, 0.3)",
  },

  fontSize: props.width > 748 ? "16px" : "",
  borderRadius: props.width > 748 ? "30px" : "",
  padding: props.width > 748 ? "20px 10px" : "5px 10px",
}));

// Icon Component //
export const SearchIconStyled = styling(Search)((props) => ({
  fontSize: props.width ? "1.4rem" : "1rem",
}));

export const LinkStyled = styling(Link)(({ theme }) => ({
  textDecoration: "none",
}));
